import { useTranslations } from '@vocab/react';
import {
  Box,
  Button,
  Card,
  Column,
  Columns,
  Drawer,
  Text,
} from 'braid-design-system';
import React, { useEffect, useState } from 'react';
import translations from './.vocab';
import FormContainer from './Form/FormContainer';
import { useAnalytics } from 'src/contexts/AnalyticsContext';

export const DeleteAccount = () => {
  const { t } = useTranslations(translations);
  const { trackAccountLink } = useAnalytics();

  const [openingEventTriggered, setOpeningEventTriggered] =
    React.useState(false);
  useEffect(() => {
    if (openingEventTriggered) {
      trackAccountLink({
        eventName: 'settings_section_displayed',
        currentPageSection: 'delete account',
      });
    }
  }, [openingEventTriggered, trackAccountLink]);

  const [drawerOpened, setDrawerOpened] = useState(false);
  const toggle = () => {
    const wasClosed = drawerOpened === false;
    if (wasClosed) {
      setOpeningEventTriggered(true);
    }
    setDrawerOpened((currentState) => !currentState);
  };

  return (
    <Box data-testid="delete-account-card">
      <Card rounded>
        <Columns space="small">
          <Column>
            <Text weight="strong">{t('Delete account')}</Text>
          </Column>
          <Column width="content">
            <Button
              id="deleteAccountButton"
              tone="critical"
              variant="transparent"
              bleed
              onClick={toggle}
            >
              {t('Delete')}
            </Button>
          </Column>
        </Columns>
      </Card>

      <Drawer
        id="deleteAccountDrawer"
        title={t('Delete account')}
        open={drawerOpened === true}
        onClose={toggle}
        width="small"
      >
        <Text>
          {t(
            'Delete your account and all of your stored information. This cannot be undone.',
          )}
        </Text>

        <FormContainer toggle={toggle} />
      </Drawer>
    </Box>
  );
};

export default DeleteAccount;
